import React, { useState, useEffect } from 'react';

const useHydrate = () => {
  const [hydrated, hydrate] = useState(false);

  useEffect(() => {
    hydrate(true);
  }, []);

  return hydrated;
};

export default useHydrate;
